export const CHANNEX_GUEST_ID_PREFIX = "CHANNEX_GUEST";
export const CHANNEX_GUEST_DISPLAY_NAME = "Channex guest";
